import React, { Component } from 'react';

import { Redirect } from "react-router-dom";
import { Grid, Row, Col } from "react-bootstrap";

import { CustomCard } from "../../components/Card/CustomCard";
import Publicacion from "./Publicacion";
import Calendar from "./Calendar";
import Agenda from "./Agenda";

import Preloader from "../../views/Preloader/Preloader";
import CheckData from '../../shared/CheckData';

let statusUser = 0;

let date = new Date;
let day = date.getDate();
let month = date.getMonth() + 1;
let year = date.getFullYear();

let hoy = `${day}/${month}/${year}`;

class Noticias extends Component {
    state = {
        statusUser: 0,
        diaSelect: hoy
    }

    constructor (props) {
        super (props);
        CheckData((resp) => {console.log(resp);
            statusUser = parseInt(resp)
            this.setState ({
                statusUser: parseInt(resp)
            })
        });
    }

    cambiaDia = (dia) => {
        this.setState({ diaSelect: dia })
    }

    noticias = () => {
        return (
            <React.Fragment>
                <Agenda dia={this.state.diaSelect}/>
                <Publicacion/>
            </React.Fragment>
        );
    }
    
    contenidOk = () => {
        return (
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col md={8}>
                            <CustomCard
                                title="Noticias Recientes"
                                color="#a80012"
                                content={this.noticias()}
                            />
                        </Col>
                        <Col md={4}>
                            <CustomCard
                                title="Calendario Académico"
                                color="a80012"
                                content={<Calendar  funcion = { (dia) => {this.cambiaDia(dia)} } today={date}/>}
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }

    render() {
        switch (statusUser) {
            case 0:
                return(<Preloader/>) 
            case 1:
                return (<Redirect to="/admision" />)
            case 2:
                return (this.contenidOk())
            case 3:
                return (this.contenidOk())
            case 4:
                return (<Redirect to="/admision" />)
            case 5:
                return (<Redirect to="/admision" />)
            default:
                return(<Preloader/>) 
        }
    }
}
 
export default Noticias;



// WEBPACK FOOTER //
// ./src/views/Noticias/Noticias.jsx